import React from 'react';
import PropTypes from 'prop-types';
import { ellipsify } from '../../../utilities/helperFunctions';
import UserImage from '../../Content/User/UserDisplay/UserImage/UserImage';
import UnderlineNavigation from '../../Elements/UnderlineNavigation/UnderlineNavigation';
import Button from '../../Input/Button/Button';
import KarmaScoreDisplay from '../../Users/KarmaScoreDisplay/KarmaScoreDisplay';
import { PageContext } from '../../../contexts/ContextCreator';
import { PAGE_DISPLAY_MODE } from '../../../pages/constants';

import './UserCallToAction.scss';
import JobNotificationsBox from '../../LeftRail/JobNotificationsBox/JobNotificationsBox';

const pluralize = (count) => (count !== 1 ? 's' : '');

export const createStatItems = (postCount = 0, commentCount = 0) => {
    return [
        {
            text: `${postCount || 0} Post${pluralize(postCount)}`,
            url: '/users/contributions/post',
            active: true,
        },
        {
            text: `${commentCount || 0} Comment${pluralize(commentCount)}`,
            url: '/users/contributions/comment',
            active: true,
        },
    ];
};

export default class UserCallToAction extends React.PureComponent {
    isUserView = () => {
        return !!(
            this.context.pageDisplayMode === PAGE_DISPLAY_MODE.USER_DEFAULT
        );
    };

    render() {
        const { session } = this.context.pageProps;
        const {
            username,
            logo,
            credential,
            location,
            userContentCounts,
            jobTitle,
        } = session;
        const karmaScore =
            userContentCounts && userContentCounts.karmaScore
                ? userContentCounts.karmaScore
                : 10;
        const authorImage = {
            src: logo || '/v1/avatar_black_160_vtg7lw.svg',
            alt: `${username || 'default'} img`,
        };

        const postCount =
            userContentCounts && userContentCounts.contentCount
                ? userContentCounts.contentCount
                : 0;
        const commentCount =
            userContentCounts && userContentCounts.commentCount
                ? userContentCounts.commentCount
                : 0;

        let body = (
            <React.Fragment>
                <div className="user-image-container">
                    <UserImage
                        isVip={false}
                        image={authorImage}
                        iconSize={84}
                    />
                </div>
                <div className="username">Mystery Woman</div>
                <div className="message default-message">
                    Tell us more for better jobs, advice <br /> and connections
                </div>
                {this.context.wrapAuth(
                    'CreateContent',
                    <div className="button-div">
                        <Button type="solid" value="Sign In" />
                    </div>,
                    { login_trigger: 'profile-call-to-action' }
                )}
            </React.Fragment>
        );

        if (session && Object.keys(session).length) {
            const credentialComponent = credential && (
                <div className="message credential">
                    {ellipsify(credential, 50)}
                </div>
            );
            const jobTitleComponent = jobTitle && (
                <div className="message credential">
                    {ellipsify(jobTitle, 50)}
                </div>
            );
            const secondaryComponent = location && (
                <div className="location">{ellipsify(location, 48)}</div>
            );
            const karmaScoreComponent = (
                <KarmaScoreDisplay karmaScore={karmaScore} />
            );

            const userContributionsArray = createStatItems(
                postCount,
                commentCount
            );

            const userColumnStat = (
                <a href="/users/contributions/post">
                    <Button
                        type="solid-wired-blue"
                        value="My items"
                        inputStyle="my-items-btn"
                    />
                </a>
            );

            const underlineNavigation = (
                <UnderlineNavigation
                    menuItems={userContributionsArray.slice(0, 2)}
                />
            );
            const userContributionComponent =
                userColumnStat || underlineNavigation;
            const linkUrl = this.isUserView()
                ? '/users/profile'
                : '/employers/profile';

            const minimizedProfileCard = this.props.jobSearchView;

            const userJobAlertsSection = (
                <JobNotificationsBox
                    {...this.context.jobNotifications}
                    openModal={() => this.context.modalTrigger('FollowedJobs')}
                    profileCardView={minimizedProfileCard}
                />
            );
            body = (
                <React.Fragment>
                    <a className="user-profile-link" href={linkUrl}>
                        <div className="user-image-container">
                            <UserImage
                                isVip={
                                    session.userCommunityData &&
                                    session.userCommunityData.isVip
                                }
                                image={authorImage}
                                iconSize={84}
                            />
                        </div>
                        <div className="username">
                            {username
                                ? ellipsify(username, 40)
                                : 'Mystery Woman'}
                        </div>
                        {this.isUserView() &&
                            !minimizedProfileCard &&
                            karmaScoreComponent}
                        {this.isUserView() &&
                            !minimizedProfileCard &&
                            credentialComponent}
                        {!this.isUserView() && jobTitleComponent}
                        {this.isUserView() && secondaryComponent}
                    </a>
                    {this.isUserView() &&
                        !minimizedProfileCard &&
                        userContributionComponent}
                    {this.isUserView() &&
                        minimizedProfileCard &&
                        userJobAlertsSection}
                </React.Fragment>
            );
        }
        return (
            <div className="component-CallToAction-UserCallToAction">
                <div className="user-cta-container new-styling">{body}</div>
            </div>
        );
    }
}

UserCallToAction.propTypes = {
    /**
     * whether current page is JobsSearchLanding
     */
    jobSearchView: PropTypes.bool,
};

UserCallToAction.defaultProps = {
    jobSearchView: false,
};

UserCallToAction.contextType = PageContext;
